<template>
    <form-view class="schema-service-detail-view">
        <template slot="field">
            <veui-field label="应用名称：">
                <veui-span>{{ store.serviceDetail.appName }}</veui-span>
            </veui-field>
            <veui-field label="服务名称：">
                <veui-span>{{ store.serviceDetail.name }}</veui-span>
            </veui-field>
            <veui-field label="authKey：">
                <veui-span>{{ authKey }}</veui-span>
            </veui-field>
            <veui-field label="activityId：">
                <veui-span>{{ activityId }}</veui-span>
            </veui-field>
            <veui-field label="数据接收邮箱：">
                <veui-span>{{ mailReceiver }}</veui-span>
            </veui-field>
            <veui-field label="数据解压密码：">
                <veui-span>{{ zipPassword }}</veui-span>
            </veui-field>
        </template>
        <template slot="operation">
            <veui-button @click="goToServiceList">{{ cancelText }}</veui-button>
        </template>
    </form-view>
</template>

<script>
import FormView from '@baidu/ve-ria/views/FormView';
import DetailModel from './DetailModel';
import createView from '@baidu/ve-ria/views/createView';
import {Field, Button, Span} from 'veui';
import serviceMixin from '@/common/mixins/service';
import {get} from 'lodash';

export default createView(FormView, DetailModel, {
    name: 'SchemaServiceDetailView',
    components: {
        'veui-field': Field,
        'veui-span': Span,
        'veui-button': Button
    },
    mixins: [serviceMixin],
    computed: {
        mailReceiver() {
            return get(this.store.serviceDetail, 'data.mailReceiver');
        },
        zipPassword() {
            return get(this.store.serviceDetail, 'data.zipPassword');
        }
    }
});
</script>
